import {
  Select,
  SelectContent,
  SelectContentProps,
  SelectTrigger,
} from '@synoptic/ui-kit/select/select.tsx';
import { PropsWithChildren } from 'react';
import { useSearchParams } from 'react-router';
import {
  streamFiltersContainer,
  streamFilterTrigger,
  streamFilterTriggerContainer,
} from '@/routes/_app.p.marketplace.streams/stream-filters/stream-filters.css.ts';
import {
  addSearchParams,
  deleteSearchParams,
} from '@/utils/handle-search-param.ts';

export const StreamFilters = ({ children }: PropsWithChildren) => {
  return <div className={streamFiltersContainer}>{children}</div>;
};
export const StreamFilterItem = ({
  paramName,
  defaultValue,
  optionsEntity,
  options,
}: {
  paramName: string;
  defaultValue: string;
  optionsEntity: Record<string, string>;
  options: SelectContentProps['items'];
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const param = searchParams.get(paramName) || defaultValue;
  const value = Object.hasOwn(optionsEntity, param) ? param : defaultValue;

  return (
    <Select
      value={value}
      onValueChange={(v) => {
        if (v === defaultValue) {
          setSearchParams(deleteSearchParams(searchParams, [paramName]), {
            preventScrollReset: true,
          });

          return;
        }

        setSearchParams(
          addSearchParams(searchParams, [{ name: paramName, value: v }]),
          {
            preventScrollReset: true,
          },
        );
      }}
    >
      <SelectTrigger
        variant={'outline'}
        containerClassName={streamFilterTriggerContainer}
        className={streamFilterTrigger}
      />
      <SelectContent position="popper" items={options} />
    </Select>
  );
};
